import {
  GwpVariantPickerUserInterface,
  MessageBoxUserInterface,
  ProgressBarUserInterface,
  QuantityButtonsUserInterface,
  UserInterfaceDto,
  WidgetDto,
} from "@intelligems/ig-types";
import {
  IUserInterfacesState,
  UserInterface,
} from "@src/store/slices/userInterfaces/types";

export function getUserInterface(state: IUserInterfacesState, id: string) {
  return state.interfaces.find((i) => i.id === id) as UserInterface;
}

export function isQuantityButtonsInterface(
  userInterface: UserInterfaceDto | undefined
): userInterface is QuantityButtonsUserInterface {
  const type = userInterface?.widget?.widgetType;
  if (type === "quantityButtons") {
    return true;
  }
  return userInterface?.category === "quantityButtons";
}

export function isProgressBarInterface(
  userInterface: UserInterfaceDto | undefined
): userInterface is ProgressBarUserInterface {
  const type = userInterface?.widget?.widgetType;
  if (type === "discountProgressBar" || type === "shippingProgressBar") {
    return true;
  }
  return userInterface?.category === "progressBar";
}

export function isMessageBoxInterface(
  userInterface: UserInterfaceDto | undefined
): userInterface is MessageBoxUserInterface {
  const type = userInterface?.widget?.widgetType;
  if (type === "messageBoxPopup" || type === "messageBoxSlideOut") {
    return true;
  }
  return userInterface?.category === "messageBox";
}

export function isGwpVariantPickerInterface(
  userInterface: UserInterfaceDto | undefined
): userInterface is GwpVariantPickerUserInterface {
  if (userInterface?.widget?.widgetType === "gwpVariantPicker") {
    return true;
  }
  return userInterface?.category === "gwpVariantPicker";
}

export function updateUserInterfaceWidgets(
  userInterfaces: UserInterfaceDto[] | undefined,
  widget: WidgetDto
) {
  if (!userInterfaces) {
    return undefined;
  }

  for (const userInterface of userInterfaces) {
    if (userInterface.widget?.id === widget.id) {
      userInterface.widget = widget;
    }
  }
}

export function resolveEnabledWidgets(options: {
  quantityButtonsEnabled?: boolean;
  discountProgressBarsEnabled?: boolean;
  shippingProgressBarsEnabled?: boolean;
  messageBoxPopupsEnabled?: boolean;
  messageBoxSlideOutsEnabled?: boolean;
  gwpVariantPickersEnabled?: boolean;
}) {
  const quantityButtons = !!options.quantityButtonsEnabled;
  const discountProgressBars = !!options.discountProgressBarsEnabled;
  const shippingProgressBars = !!options.shippingProgressBarsEnabled;
  const messageBoxPopups = !!options.messageBoxPopupsEnabled;
  const messageBoxSlideOuts = !!options.messageBoxSlideOutsEnabled;
  const gwpVariantPickers = !!options.gwpVariantPickersEnabled;
  const progressBars = discountProgressBars || shippingProgressBars;
  const messageBoxes = messageBoxPopups || messageBoxSlideOuts;
  const widgets =
    quantityButtons ||
    progressBars ||
    shippingProgressBars ||
    messageBoxPopups ||
    messageBoxSlideOuts ||
    gwpVariantPickers;
  return {
    quantityButtons,
    discountProgressBars,
    shippingProgressBars,
    messageBoxPopups,
    messageBoxSlideOuts,
    gwpVariantPickers,
    progressBars,
    messageBoxes,
    widgets,
  };
}
